import { render } from "./HeaderSubDiv.vue?vue&type=template&id=b66ff470&scoped=true"
import script from "./HeaderSubDiv.vue?vue&type=script&lang=js"
export * from "./HeaderSubDiv.vue?vue&type=script&lang=js"

import "./HeaderSubDiv.vue?vue&type=style&index=0&id=b66ff470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66ff470"]])

export default __exports__